/**
 * Directional lobe amplitude — shared by rules + sonar cast (no circular deps).
 */

function clamp(v: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, v));
}

/**
 * Directional noise lobe amplitude at angle θ relative to world.
 * facingRad = atan2(facingY, facingX).
 */
export function lobeAmp(
  theta: number,
  facingRad: number,
  sideAmp: number,
  forwardPower: number,
): number {
  const side = clamp(sideAmp, 0, 1);
  const d = theta - facingRad;
  const cos = Math.cos(d);
  const forward = Math.max(0, cos);
  return side + (1 - side) * Math.pow(forward, Math.max(0.1, forwardPower));
}
